<template>
	<div>
		<common-header navbar-index=2></common-header>
		<robot-banner></robot-banner>
		<div class="container" id="link1">
			<div class="tips mt-5 pt-4 pb-4">
				<a href="javascript:void(0)" @click="toback">行业新闻</a><span class="s1">|</span><span class="s2">编程已加入高考，家长和孩子们该如何应对</span>
			</div>
			<div class="content_item pt-4 pb-5">
				<div class="pl25 pr25">
					<div class="title mb-4">编程已加入高考，家长和孩子们该如何应对</div>
					<p class="text">在2017年浙江省首度开考信息技术科目时，大家都戏称：“连玩电脑也要考试了！”</p>
					<p class="text">也就是说浙江高考除了必考语文、数学、外语之外，还要从政治、历史、地理、物理、化学、生物、技术（含通用技术和信息技术）等7门设有加试题的高中学考科目中，选择3门作为高考选考科目。这一次浙江可以说已经率先一步走在了前面。之后不止浙江，教育大省北京和山东也确定要把编程基础纳入信息技术课程和高考的内容体系。</p>
					<p style="text-align:center"><img alt="" height="449" src="../../../assets/img/robot/article/5_1.png" width="659"></p>
					<p class="text2">△图片来源于网络</p>
					<p class="text">而2018年的高考有这么一道题成功引起了大家的注意，乍一看是不是会下意识觉得这肯定是选考科目信息技术里的编程题？</p>
					<p style="text-align:center"><img alt="" height="314" src="../../../assets/img/robot/article/5_2.png" width="656"></p>
					<p class="text2">△图片来源于网络</p>
					<p class="text">NO,NO！为什么说成功引起了大家的注意，因为这是全国1卷的文科第8题以及全国2卷的理科第7题。</p>
					<p class="text">也就是说2018年不仅仅是“玩电脑也要考试了”， 连必考的数学卷里面，都开始考编程了！</p>
					<p class="text">相信这场高考后肯定有不少考生执手相看泪眼：我高考又没选修信息技术，以后也不想当程序员，不打算考计算机三级考试，没想到还是要懂编程！</p>
					<p style="text-align:center"><img alt="" height="438" src="../../../assets/img/robot/article/5_3.png" width="655"></p>
					<p class="text2">△图片来源于网络</p>
					<p class="text">其实编程也没有想象中这么吓人，这些看着和编程有关的考题考的不是什么精深的算法，更多的是<b style="color: #f39c12;">编程思维</b>。</p>
					<p style="text-align:center"><img alt="" height="438" src="../../../assets/img/robot/article/5_4.png" width="658"></p>
					<p class="text2">△图片来源于网络</p>
					<p class="text">并非每个人都会成为程序员，但学习编程可以<b style="color: #f39c12;">提升逻辑思维能力、抽象思维能力和解决问题能力</b>对孩子有益无害，这也将受到越来越多学校和家长的认同。有编程思维的孩子，必须具备的素质就是逻辑思维强、做事有条理，注意力集中而且能静心，很多优秀的学校最看重的就是这些。而孩子从小就学习和使用这种思维方式，长大了运用在应试中也会比临时抱佛脚的学习来得更加扎实和显效。</p>
					<p style="text-align:center"><img alt="" height="343" src="../../../assets/img/robot/article/5_5.png" width="653"></p>
					<p class="text2">△图片来源于网络</p>
					<p class="text">编程思维并没有那么复杂，它其实是解决问题的一种方法，是逻辑思维的一种，就是利用我们已有的知识和工具，将自身的思路转化成逻辑运算的步骤，从而完成复杂的任务。“编程思维”就是“理解问题——找出路径”的思维过程，它由分解—识别模式—抽象—算法四个步骤组成：</p>
					<p class="text"><b style="color: #333;">分解</b>，把一个复杂的大问题，拆解成更可执行、更好理解的小步骤。</p>
					<p class="text"><b style="color: #333;">模式识别</b>，找出相似模式，高效解决细分问题。</p>
					<p class="text"><b style="color: #333;">抽象</b>，聚焦最重要的信息，忽视无用细节。</p>
					<p class="text"><b style="color: #333;">算法</b>，设计一步一步的解决路径，解决整个问题。</p>
					<p class="text">简单一点说，编程思维就是处理问题的正确打开方式。拥有这样的思维方式，孩子们会在解数学难题时也更加的得心应手，无论做什么事情都会比普通思维方式更容易成功。</p>
					<p style="text-align:center"><img alt="" height="637" src="../../../assets/img/robot/article/5_6.png" width="660"></p>
					<p class="text2">△图片来源于网络</p>
					<p class="text">编程这一门新兴课程以前可以算是一门选修课，但是现已正式加入了高考必修的豪华午餐中，成为每个孩子必备的一种技能，赶紧GET起来吧！</p>

					<p class="text">&nbsp;</p>
					<p style="text-align:left">原文链接：
						<a target="_blank" href="http://www.robotest.cn/article/item-291.html">http://www.robotest.cn/article/item-291.html</a>
					</p>
					<div class="clear"></div>
				</div>
			</div>
		</div>
		<common-footer></common-footer>
	</div>
</template>

<script>
	import CommonHeader from '@/pages/common/Header'
	import RobotBanner from '@/pages/robot/components/RobotBanner'
	import CommonFooter from '@/pages/common/Footer'
	import axios from 'axios'
	export default {
		name: 'Article5',
		components: {
			CommonHeader,
			RobotBanner,
			CommonFooter
		},
		data() {
			return {}
		},
		methods: {
			toback() {
				this.$router.push({
					path: '/robot/desc'
				})
			}
		},
		mounted() {
			document.getElementById('link1').scrollIntoView()
		}
	};
</script>

<style lang="scss" scoped>
	.content_item a {
		color: #000000;
		text-decoration: none;
	}
	
	div.title {
		font-size: 22px;
		font-weight: 600;
		text-align: center;
		letter-spacing: 2px;
	}
	
	p.tag {
		font-size: 20px;
		font-weight: 600;
		margin-top: 30px;
	}
	
	p.text {
		font-size: 16px;
		line-height: 30px;
		letter-spacing: 1px;
	}
	
	p.text2 {
		font-size: 16px;
		text-align: center;
	}
	
	div.tips {
		border-bottom: 3px solid #F0F0F0;
		a {
			font-size: 24px;
			font-weight: 600;
			color: #333;
			text-decoration: none;
			cursor: pointer;
			letter-spacing: 2px;
			&:hover {
				color: #f39c12;
			}
		}
		.s1 {
			padding: 0 15px;
		}
		.s2 {
			letter-spacing: 2px;
			font-size: 18px;
		}
	}
</style>